import { useModelCreateContext } from '@rhino-project/core/hooks';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { useRenderPaths } from '../../hooks/renderPaths';
import { ModelFieldGroup } from './ModelFieldGroup';
import { FormErrors } from '../forms/FormErrors';
import { Form } from '@heroui/react';

export interface ModelCreateFormProps {
  paths?: string[];
}

export const ModelCreateFormBase = (props: ModelCreateFormProps) => {
  const { paths } = useModelCreateContext();
  const renderPaths = useRenderPaths(props.paths || paths, {
    Component: ModelFieldGroup
  });

  return (
    <Form>
      <FormErrors />
      {renderPaths}
    </Form>
  );
};

export const ModelCreateForm = (props: ModelCreateFormProps) =>
  useGlobalComponentForModel('ModelCreateForm', ModelCreateFormBase, props);
